import { render, staticRenderFns } from "./PolicyChangeConfirmationDialog.vue?vue&type=template&id=b2bc1104&"
import script from "./PolicyChangeConfirmationDialog.vue?vue&type=script&lang=ts&"
export * from "./PolicyChangeConfirmationDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports